export default "__VITE_ASSET__97dd272a__"